export default "__VITE_ASSET__702c7e6c__"